/* eslint-disable @typescript-eslint/ban-types */
import * as d3 from 'd3';

export const colorRanges = {
  whiteRed: ['#FFFFFF', '#f9eded', '#db9491', '#d47f7b', '#cd6965', '#c6544e', '#b82a23'],
  whiteRedBlue: ['#b82a23', '#e0534c', '#fa948e', '#F5F5F5', '#d9f0ff', '#7ebae0', '#5499c4'],
  purpule: ['#FFFFFF', '#653397'],
};

export type ColorSchemName = keyof typeof colorRanges;

export const colorScheme: Record<ColorSchemName, any> = {
  whiteRed: (min: number, max: number) =>
    d3
      .scaleLinear()
      .range(colorRanges.whiteRed as any)
      .domain([min, -1, -0.1, 0, 0.1, 1, max]),
  whiteRedBlue: (min: number, max: number) =>
    d3
      .scaleLinear()
      .range(colorRanges.whiteRedBlue as any)
      .domain([min, -1, -0.1, 0, 0.1, 1, max]),

  purpule: (min: number, max: number) => d3.scaleSequential(d3.interpolatePurples).domain([min, max]),
};
